import { useState } from 'react';

import { DEFAULT_FILTERS } from '@ion/api/audit-logs/query';

export default function useAuditLogFilters() {
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const setChildType = childType => setFilters(current => ({ ...current, childType, childId: null }));
  const setChildId = childId => setFilters(current => ({ ...current, childId }));
  const setAction = action => setFilters(current => ({ ...current, action }));
  const setUserSearchTerm = userSearchTerm => setFilters(current => ({ ...current, userSearchTerm }));
  const setDateRange = dateRange => setFilters(current => ({ ...current, dateRange }));

  return { filters, setChildType, setChildId, setAction, setUserSearchTerm, setDateRange };
}
